// extracted by mini-css-extract-plugin
module.exports = {"container":"Certificates_container__MDeY1","images":"Certificates_images__7OkkO"};